import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import HowItWorksPage from "./pages/HowItWorks";
import ScrollToTop from "./ScrollToTop";
import ClubsPage from "./pages/Clubs";
import Platinum from "./pages/Platinum";
import VehiclesPage from "./pages/Vehicles";
import Explore from "./pages/explore";
import Adventure from "./pages/Adventure";
import Elite from "./pages/Elite";
import Analytics from "./analytics/Analytics";
import Learn from "./pages/Learn";
import About from "./pages/About";
import FoundingMembers from "./pages/FoundingMembers";
import { AdminAuthProvider } from "./admin/auth/AdminAuthProvider";
import AdminGate from "./admin/AdminGate";

function App() {
  return (
    <Router>
      <Analytics />
      <ScrollToTop />

      <Routes>
        <Route
          path="/admin/*"
          element={
            <AdminAuthProvider>
              <AdminGate />
            </AdminAuthProvider>
          }
        />

        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          
          <Route path="how-it-works" element={<HowItWorksPage />} />
          <Route path="clubs" element={<ClubsPage />} />
          <Route path="vehicles" element={<VehiclesPage />} />
          <Route path="explore" element={<Explore />} />
          <Route path="adventure" element={<Adventure />} />
          <Route path="elite" element={<Elite />} />
          <Route path="platinum" element={<Platinum />} />
          <Route path="learn" element={<Learn />} />
          <Route path="about" element={<About />} />
          <Route path="founding-members" element={<FoundingMembers />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;